import location from "./location";
import persist from "./persist";

export default [location, persist];



// WEBPACK FOOTER //
// ./src/store/plugins/index.js